import { render, staticRenderFns } from "./UsageSummary.vue?vue&type=template&id=2098f7e6&scoped=true&"
import script from "./UsageSummary.vue?vue&type=script&lang=js&"
export * from "./UsageSummary.vue?vue&type=script&lang=js&"
import style0 from "./UsageSummary.vue?vue&type=style&index=0&id=2098f7e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098f7e6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/usage/UsageSummary.vue
// module id = 979
// module chunks = 0